function createActionTypes(section, keys) {
  const typesObj = {};

  if (!Array.isArray(keys)) {
    keys = [keys];
  }

  keys.forEach((key) => {
    typesObj[key] = section + '/' + key;
  });

  return typesObj;
}

export const readerCards = createActionTypes('reader_cards', [
  'FETCH_READER_CARDS_SUCCESS',
  'FETCH_READER_CARDS_REQUEST',
]);

export const messagesInbox = createActionTypes('messages_inbox', [
  'FETCH_MESSAGE_THREADS_REQUEST',
  'FETCH_MESSAGE_THREADS_SUCCESS',
  'REMOVE_MESSAGE_THREAD',
  'MARK_MESSAGE_THREAD_AS_READ',
  'ADD_MESSAGE_TO_THREAD',
  'SEND_MESSAGE_REQUEST',
  'SEND_MESSAGE_FAILURE',
  'CLEAR_SENDING_ERROR',
  'SET_REPLY_VALUE',
]);

export const searchResults = createActionTypes('search_results', [
  'UPDATE_WORKS',
  'FETCH_RI_FOLLOWER_COUNT_SUCCESS',
  'FETCH_ACTOR_DATA_SUCCESS',
  'FOLLOW_USER_SUCCESS',
  'UNFOLLOW_USER_SUCCESS',
  'FOLLOW_RI_SUCCESS',
  'UNFOLLOW_RI_SUCCESS',
]);

export const analyticsDashboard = createActionTypes('analytics_dashboard', [
  // Hits
  'FETCH_HITS_REQUEST',
  'FETCH_HITS_SUCCESS',
  'FETCH_HITS_FAILURE',
  // SiteSearches
  'FETCH_SITE_SEARCHES_REQUEST',
  'FETCH_SITE_SEARCHES_SUCCESS',
  'FETCH_SITE_SEARCHES_FAILURE',
  // PreviousDateRangeHits
  'FETCH_OLD_HITS_REQUEST',
  'FETCH_OLD_HITS_SUCCESS',
  'FETCH_OLD_HITS_FAILURE',
  // Countries
  'FETCH_COUNTRIES_REQUEST',
  'FETCH_COUNTRIES_SUCCESS',
  'FETCH_COUNTRIES_FAILURE',
  // Downloads
  'FETCH_DOWNLOADS_REQUEST',
  'FETCH_DOWNLOADS_SUCCESS',
  'FETCH_DOWNLOADS_FAILURE',
  // PreviousDateRangeDownloads
  'FETCH_OLD_DOWNLOADS_REQUEST',
  'FETCH_OLD_DOWNLOADS_SUCCESS',
  'FETCH_OLD_DOWNLOADS_FAILURE',
  // Referers
  'FETCH_REFERER_PAIRS_REQUEST',
  'FETCH_REFERER_PAIRS_SUCCESS',
  'FETCH_REFERER_PAIRS_FAILURE',
  // DisplayedDates
  'SET_DISPLAYED_DATES',
  // Works
  'FETCH_WORKS_REQUEST',
  'FETCH_WORKS_SUCCESS',
  'FETCH_WORKS_FAILURE',
  // Docs
  'FETCH_DOCS_REQUEST',
  'FETCH_DOCS_SUCCESS',
  'FETCH_DOCS_FAILURE',
  // ReaderResearchInterests
  'FETCH_READER_RESEARCH_INTERESTS_REQUEST',
  'FETCH_READER_RESEARCH_INTERESTS_SUCCESS',
  'FETCH_READER_RESEARCH_INTERESTS_FAILURE',
  // Percentiles
  'FETCH_PERCENTILES_REQUEST',
  'FETCH_PERCENTILES_SUCCESS',
  'FETCH_PERCENTILES_FAILURE',
  // ResearchInterestPercentiles
  'FETCH_RESEARCH_INTEREST_PERCENTILES_REQUEST',
  'FETCH_RESEARCH_INTEREST_PERCENTILES_SUCCESS',
  'FETCH_RESEARCH_INTEREST_PERCENTILES_FAILURE',
  // ImpactAggregations
  'FETCH_IMPACT_AGGREGATIONS_REQUEST',
  'FETCH_IMPACT_AGGREGATIONS_SUCCESS',
  'FETCH_IMPACT_AGGREGATIONS_FAILURE',
]);

export const profileVisitorCards = createActionTypes('profile_visitor_cards', [
  'UPDATE_PROFILE_VISITOR_CARDS_META',
  'UPDATE_PROFILE_VISITOR_CARD',
  'FETCH_PROFILE_VISITOR_CARDS_SUCCESS',
  'FETCH_PROFILE_VISITOR_CARDS_REQUEST',
]);

export const portfolioCreation = createActionTypes('portfolio_creation', [
  'SELECT_PROVIDED_PICTURE',
]);

export const mentionsVerification = createActionTypes(
  'mentions_verifications',
  [
    'VALID_CLICK',
    'INVALID_CLICK',
    'CHECKS_CLICK',
    'FETCH_MENTION_SETTINGS_REQUEST',
    'FETCH_MENTION_SETTINGS_SUCCESS',
    'FETCH_MENTION_SETTINGS_FAILURE',
    'FETCH_RENDERED_NAMES_REQUEST',
    'FETCH_RENDERED_NAMES_SUCCESS',
    'FETCH_RENDERED_NAMES_FAILURE',
    'INPUT_FIELD_CHANGE',
    'FETCH_TOTAL_MENTIONS_REQUEST',
    'FETCH_TOTAL_MENTIONS_SUCCESS',
    'FETCH_TOTAL_MENTIONS_FAILURE',
    'DATA_ALREADY_LOADED',
    'LOAD_MENTIONS_SETTING_DATA',
  ],
);

export const libraryPage = createActionTypes('library_page', [
  'INITIALIZE_WORKS',
  'UPDATE_WORKS',
  'FETCH_RELATED_WORKS_SUCCESS',
  'FETCH_RI_FOLLOWER_COUNT_SUCCESS',
  'FETCH_ACTOR_DATA_SUCCESS',
  'FOLLOW_USER_SUCCESS',
  'UNFOLLOW_USER_SUCCESS',
  'FOLLOW_RI_SUCCESS',
  'UNFOLLOW_RI_SUCCESS',
  'INITIALIZE_WORK_COLLECTIONS',
  'FETCH_WORK_COLLECTION_START',
  'FETCH_WORK_COLLECTION_SUCCESS',
  'FETCH_WORK_COLLECTION_ERROR',
  'ADD_WORK_COLLECTION_START',
  'ADD_WORK_COLLECTION_SUCCESS',
  'ADD_WORK_COLLECTION_ERROR',
  'UPDATE_WORK_COLLECTION_START',
  'UPDATE_WORK_COLLECTION_SUCCESS',
  'UPDATE_WORK_COLLECTION_ERROR',
  'DELETE_WORK_COLLECTION_START',
  'DELETE_WORK_COLLECTION_SUCCESS',
  'DELETE_WORK_COLLECTION_ERROR',
  'ADD_ITEM_TO_COLLECTION_START',
  'ADD_ITEM_TO_COLLECTION_SUCCESS',
  'ADD_ITEM_TO_COLLECTION_ERROR',
  'DELETE_ITEM_FROM_COLLECTION_START',
  'DELETE_ITEM_FROM_COLLECTION_SUCCESS',
  'DELETE_ITEM_FROM_COLLECTION_ERROR',
  'SET_ACTIVE_STATE',
  'SET_DEFAULT_EXPANDED',
]);

export const coronavirusPage = createActionTypes('coronavirus_page', [
  'INITIALIZE_WORKS',
  'UPDATE_WORKS',
  'ADD_WORKS',
  'FETCH_RELATED_WORKS_SUCCESS',
  'FETCH_RI_FOLLOWER_COUNT_SUCCESS',
  'FETCH_ACTOR_DATA_SUCCESS',
  'FOLLOW_USER_SUCCESS',
  'UNFOLLOW_USER_SUCCESS',
  'FOLLOW_RI_SUCCESS',
  'UNFOLLOW_RI_SUCCESS',
]);
